export default __webpack_public_path__ + "4639f156a1c7281681050d8207bbb1ff.svg";